import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";

const testimonials = [
  {
    heading: "Best Online Casino in Malaysia!",
    desc: "“I’ve tried many platforms, but Heng Ong Bet Malaysia is the best. The games are fun and the support team is great. I won big on Heng Ong Bet Slot!”",
    by: "Ahmad Faizal, Kuala Lumpur",
  },
  {
    heading: "Smooth App Experience on Android",
    desc: "“The Heng Ong Bet Android app is fast and easy to use. I downloaded it from ori-hengongbet.com and started playing within minutes.”",
    by: "Nur Aisyah, Penang",
  },
  {
    heading: "Love the Welcome Bonus & Free Credit",
    desc: "“When I registered at Heng Ong Bet, I got a welcome bonus and free credit. It helped me play more games and understand how Hengongbetplay works!”",
    by: "Lim Wei Han, Johor Bahru",
  },
  {
    heading: "Easy to Register and Login",
    desc: "“I used the Heng Ong Bet Register page on ori-hengongbet.com. The process was fast and the Heng Ong Bet Login worked without issues.”",
    by: "Siti Mariam, Selangor",
  },
  {
    heading: "Great Slot Games and H5 Version",
    desc: "“I love playing on Hengongbet88 and Heng Ong Bet H5 when I’m not at home. No lag, just smooth fun. Heng Ong Bet Casino is really the best!”",
    by: "Daniel Chong, Melaka",
  },
];

const Testimonial = () => {
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={10}
      slidesPerView={1}
      loop={true}
      autoplay={{ delay: 3500, disableOnInteraction: false }}
      /*  style={{ width: "100%", height: "auto" }} */
    >
      {testimonials.map((testimonial, i) => {
        return (
          <>
            <SwiperSlide key={i}>
              <div key={i} className="testimonial-item">
                <p className="testimonial-head">{testimonial.heading}</p>
                <p className="testimonial-desc">{testimonial.desc}</p>
                <p className="testimonial-by">{testimonial.by}</p>
              </div>
            </SwiperSlide>
          </>
        );
      })}
    </Swiper>
  );
};

export default Testimonial;
